(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirefdb2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2JCzs", function(module, exports) {

$parcel$export(module.exports, "arrows", function () { return $1fddb41f226a4383$export$80adc0c60c17ef1e; });
$parcel$export(module.exports, "keyboard", function () { return $1fddb41f226a4383$export$cfdd767f5a513509; });
function $1fddb41f226a4383$var$removeElement(elment) {
    elment.parentNode.removeChild(elment);
}
function $1fddb41f226a4383$var$createBtn(className) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var btn = document.createElement('button');
    btn.setAttribute('type', 'button');
    if (type) btn.setAttribute('aria-label', type);
    var classNames = className.split(' ');
    classNames.forEach(function(name) {
        return btn.classList.add(name);
    });
    return btn;
}
var $1fddb41f226a4383$export$80adc0c60c17ef1e = function(slider) {
    var markup = function markup(remove) {
        arrowMarkup(remove);
    };
    var arrowMarkup = function arrowMarkup(remove) {
        if (remove) {
            $1fddb41f226a4383$var$removeElement(arrowLeft);
            $1fddb41f226a4383$var$removeElement(arrowRight);
            return;
        }
        arrowLeft = $1fddb41f226a4383$var$createBtn('arrow arrow--left arrow--disabled', 'previous slide');
        arrowLeft.addEventListener('click', function() {
            return slider.prev();
        });
        arrowRight = $1fddb41f226a4383$var$createBtn('arrow arrow--right', 'next slide');
        arrowRight.addEventListener('click', function() {
            return slider.next();
        });
        arrowWrapper.appendChild(arrowLeft);
        arrowWrapper.appendChild(arrowRight);
    };
    var updateClasses = function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0 ? arrowLeft.classList.add('arrow--disabled') : arrowLeft.classList.remove('arrow--disabled');
        slide === slider.track.details.slides.length - 1 ? arrowRight.classList.add('arrow--disabled') : arrowRight.classList.remove('arrow--disabled');
        if (slider.track.details.maxIdx === slide) {
            arrowLeft.classList.remove('arrow--disabled');
            arrowRight.classList.add('arrow--disabled');
        }
    };
    var _slider_container;
    var arrowWrapper = slider === null || slider === void 0 ? void 0 : (_slider_container = slider.container) === null || _slider_container === void 0 ? void 0 : _slider_container.parentElement.parentElement.querySelector('.js-slider--arrows');
    if (!arrowWrapper || slider.slides.length <= 1) return;
    var arrowLeft, arrowRight;
    slider.on('created', function() {
        markup();
        updateClasses();
        var sliderElement = slider.container;
        sliderElement.classList.remove('opacity-0');
    });
    slider.on('optionsChanged', function() {
        markup(true);
        markup();
        updateClasses();
    });
    slider.on('slideChanged', function() {
        return updateClasses();
    });
    slider.on('destroyed', function() {
        return markup(true);
    });
};
var $1fddb41f226a4383$export$cfdd767f5a513509 = function(slider) {
    if (slider.slides.length <= 1) return;
    document.addEventListener('keydown', function(param) {
        var key = param.key;
        if (!key) return;
        if (key === 'ArrowLeft') slider.prev();
        if (key === 'ArrowRight') slider.next();
    });
};

});

})();
//# sourceMappingURL=slider-plugins.35fee465.js.map
